<template>
  <img
    class="utensil-loader"
    :src="loaderSrc"
    alt="Loading"
    role="img"
    aria-label="Loading"
  />
</template>

<script>
export default {
  name: 'UtensilLoader',
  data() {
    return {
      loaderSrc: require('../assets/img/loading-utensils.gif')
    }
  }
}
</script>

<style>
.utensil-loader {
  width: 150px;
  height: 150px;
  display: block;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/UtensilLoader.vue